import {createActionGroup, props} from '@ngrx/store';
import {OrderHistoryError} from 'app/core/components/error-page/order-history-error';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ErrorActions = createActionGroup({
  source: 'Error',
  events: {
    'Direct to error page': props<{error: OrderHistoryError}>(),
  },
});
